import { render } from "./LanguageSwitcher.vue?vue&type=template&id=21edb0c7"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=21edb0c7&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/LanguageSwitcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21edb0c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21edb0c7', __exports__)) {
    api.reload('21edb0c7', __exports__)
  }
  
  module.hot.accept("./LanguageSwitcher.vue?vue&type=template&id=21edb0c7", () => {
    api.rerender('21edb0c7', render)
  })

}


export default __exports__